import React from 'react'
import { object } from 'prop-types'
import { HeaderPersonalized } from './App.js'
import './index.scss'

export default class MPersonalizedHeader extends React.Component {
  render() {
    const { contentIdentifier, backgroundColor, backgroundContrast } = this.props.content
    return (
      <HeaderPersonalized
        contentIdentifier={contentIdentifier}
        backgroundColor={backgroundColor}
        backgroundContrast={backgroundContrast}
      />
    )
  }
}

MPersonalizedHeader.propTypes = {
  content: object,
}

MPersonalizedHeader.defaultProps = {
  content: {},
}
